import React, { useState, useContext } from "react";
import { DatePicker, Select, Input, Button, Table, Card, Space } from "antd";
import moment from "moment";
import useApi from "../../hooks/useApi";
import { AppStateContext } from "../../context/AppContext";
import {
  ListAttendance,
  ListBelt,
  ListBranch,
  ListCustomer,
} from "../../constants/API/API";
import { Severty, ShowToast } from "../../helper/toast";
import { EyeOutlined, SendOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import lang from "../../helper/langHelper";
import axios from "axios";
import apiPath from "../../constants/apiPath";

const { RangePicker } = DatePicker;
const { Option } = Select;

const AttendanceManagement = () => {
  const { setPageHeading } = useContext(AppStateContext);
  setPageHeading("Attendance Management");

  const [selectedBranch, setSelectedBranch] = useState(null);
  const [dateRange, setDateRange] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [branches, setBranches] = useState([]);
  const navigate = useNavigate();

  const handleView = (record) => {
    const id = record?.studentId || record?._id; // Make sure this is correct
    if (!id) {
      console.error("No ID found in record");
      return;
    }
    navigate(`/attendence/view/${id}`);
  };

  useApi({
    callback: ListBranch,
    dependencies: [],
    shouldCallApi: true,
    onSuccess: (data) => {
      const activeBranches = (data?.list || []).filter((b) => b.isActive);
      setBranches(activeBranches);
    },
    onError: (err) => console.log(err),
  });

  useApi({
    callback: ListAttendance,
    payload: { search: searchTerm, branchId: selectedBranch },
    dependencies: [searchTerm, selectedBranch],
    shouldCallApi: true,
    setLoading,
    onSuccess: ({ data }) => {
      setLoading(false);
      setList(data || []);
    },
    onError: (err) => {
      setLoading(false);
      ShowToast(err, Severty.ERROR);
    },
  });

  const sendReport = async (record) => {
    try {
      const response = await axios.post(
        apiPath.baseURL + apiPath.sendReport,
        { ...record }
      );
      ShowToast(response?.data?.message, "success");
      console.log(response);
    } catch (error) {
      ShowToast("Error while send report on email!", "error");
    }
  };

  const columns = [
    {
      title: "Student",
      dataIndex: "studentName",
      render: (text) => text || "-",
    },
    {
      title: "Class",
      dataIndex: "className",
      render: (text) => text || "-",
    },
    {
      title: "Belt",
      dataIndex: "beltName",
      render: (text) => text || "-",
    },
    {
      title: lang("Branch"),
      dataIndex: "branchName",
      render: (text) => text || "-",
    },

    {
      title: "Total",
      dataIndex: "totalCount",
      render: (_, record) =>
        record?.attendedCount !== undefined && record?.missedCount !== undefined
          ? +record.attendedCount + +record.missedCount
          : "-",
    },
    {
      title: "Attended",
      dataIndex: "attendedCount",
      render: (text) => text ?? "-",
    },
    {
      title: "Missed",
      dataIndex: "missedCount",
      render: (text) => text ?? "-",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => sendReport(record)}
            icon={<SendOutlined />}
            title="Send"
          />
          <Button
            type="primary"
            onClick={() => handleView(record)}
            icon={<EyeOutlined />}
            title="View"
          />
        </Space>
      ),
    },
  ];

  const handleExport = () => {
    if (!list || list.length === 0) {
      ShowToast("No data available to export", Severty.WARNING);
      return;
    }

    const headers = [
      "Student",
      "Class",
      "Belt",
      "Total Sessions",
      "Attended Sessions",
      "Missed Sessions",
    ];

    const csvData = list.map((record) => [
      record.studentName || "-",
      record.className || "-",
      record.beltName || "-",
      +record.attendedCount + +record.missedCount || "0",
      record.attendedCount || "0",
      record.missedCount || "0",
    ]);

    const csvContent = [headers, ...csvData].join("\n");

    // Create and trigger download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    // Generate filename with branch and date range
    const branchName =
      branches.find((b) => b._id === selectedBranch)?.name || "all-branches";
    const dateStr =
      dateRange.length === 2
        ? `${moment(dateRange[0]).format("YYYYMMDD")}-${moment(
            dateRange[1]
          ).format("YYYYMMDD")}`
        : "all-dates";
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `attendance-report-${branchName}-${dateStr}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <Card
      extra={
        <>
          <div className="pageHeadingSearch">
            <Input.Search
              placeholder="Search by Student/Parent, Class or Belt"
              allowClear
              className="searchInput"
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          {/* <Select
            placeholder="Select Branch"
            style={{ width: 200 }}
            onChange={setSelectedBranch}
            value={selectedBranch}
            allowClear
          >
            {branches?.map((branch) => (
              <Option key={branch._id} value={branch._id}>
                {branch.name}
              </Option>
            ))}
          </Select> */}

          {/* <div className="role-wrap">
            <RangePicker
              style={{ width: 200 }}
              onChange={(dates) => setDateRange(dates)}
              format="DD/MM/YYYY"
            />
          </div> */}
          <Button type="primary" onClick={handleExport}>
            Export Report
          </Button>
        </>
      }
    >
      <Table
        dataSource={list}
        columns={columns}
        rowKey="_id"
        loading={loading}
        pagination={{ pageSize: 10, showSizeChanger: true, pageSizeOptions: [10, 20, 50, 100] }}
      />
    </Card>
  );
};

export default AttendanceManagement;
